import { apiConstants } from '../config';

let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {},
        tools: {},
        map: {
            loading: false,
            reload: false,
            action: null,
            user_feature: null,
            filters: {
                types: [],
                status: [],
            },
            config: {
                layers: {
                    features: {
                        scale: .5,
                        scaleSelected: 1,
                    },
                },
                interactions: {
                    spiderfier: {
                        displayGeometry: 'circle',
                    },
                },
            }
        },
        configs: {
            uploadFiles: {
                maxFiles: 10,
                mimeTypes: [
                    'application/msword',
                    'application/vnd.ms-excel',
                    'application/vnd.ms-powerpoint',
                    'application/pdf',
                    'image/x-png',
                    'image/jpeg',
                ],
            },
        },
    },
};

export default state;